<template>
  <div>
    <div class="md:ml-20 ml-0">
      <div>
        <h1 class="text-2xl font-semibold text-ungu">
          {{ $i18n.locale == 'id' ? item.nama : item.nama_en }}
        </h1>
      </div>
      <div class="pt-5" v-html="$i18n.locale == 'id' ? item.deskripsi : item.deskripsi_en" />

      <div class="text-paragraf text-sm">
        <img class="md:-ml-0 lg:scale-100 scale-100 mt-5" :src="`${$baseUrl}/Simpanan/${item.foto}`" />
      </div>
      <div class="pt-5" v-html="$i18n.locale == 'id' ? item.persyaratan : item.persyaratan_en" />
    </div>

  </div>

</template>
<script>
export default {
  props: ['item'],
  setup() { },
};
</script>
